"use strict";

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _FoodMenu = require("../FoodMenu.context");

var _variants = require("./variants");

var MenuNavigation = function MenuNavigation(props) {
  return /*#__PURE__*/_react["default"].createElement(_FoodMenu.VariantConsumer, null, function (_ref) {
    var navDisplay = _ref.navDisplay;
    var NavigationVariant = _variants.displayVariantComponentMap.nav[navDisplay];
    return /*#__PURE__*/_react["default"].createElement(NavigationVariant, props);
  });
};

var _default = MenuNavigation;
exports["default"] = _default;